import React, { useState, useEffect } from "react";
import { createContext } from "react";
import { IAccount } from "~/types/account";
import { statsigClient } from "~/helpers/statsig"; // Importe o cliente que criamos

interface IAccountContextProps {
  account: IAccount | null;
  setAccount: React.Dispatch<React.SetStateAction<IAccount | null>>;
}

export const AccountContext = createContext<IAccountContextProps>({
  account: null,
  setAccount: () => {},
});

interface IProps {
  children: React.ReactNode;
}

export const AccountProvider: React.FC<IProps> = ({ children }) => {
  const [account, setAccount] = useState<IAccount | null>(null);

  useEffect(() => {
    const syncStatsig = async () => {
      if (account?.id) {
        await statsigClient.updateUserAsync({
          userID: String(account.id),
          email: account.email,
        });
      } else {
        await statsigClient.updateUserAsync({ userID: "" });
      }
    };

    syncStatsig();
  }, [account]);

  return (
    <AccountContext.Provider value={{ account, setAccount }}>
      {children}
    </AccountContext.Provider>
  );
};